import { ProductNotifyElement } from './product-notify-element/product-notify-element';
import { type ProductNotifyOptions } from './product-notify-content';

/**
 * @desc UI Компонент ProductNotify
 * @category 5 Notify
 * @example
 * window.app.productNotify({
 *   type: 'cart',
 *   title: 'Снуд платочка из меринос-кашемира',
 *   price: '1 490 р.',
 *   size: '6-9 мес.',
 *   color: 'Бежевый',
 *   image: '../images/content/product.jpg',
 * });
 */
export class ProductNotify {
	protected $container: HTMLElement | null;

	constructor() {
		this.$container = document.querySelector('.js-notify-layer');
		Object.assign(window.app, { productNotify: this.appendProduct.bind(this) });
	}

	public appendProduct(options: ProductNotifyOptions): void {
		if (!this.$container) return;

		const notify = new ProductNotifyElement(this.$container, options);
		notify.open();
	}
}

export type { ProductNotifyOptions };
